module.exports = __webpack_public_path__ + "img/57.b40b425e.jpg";